import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-skeleton-loader",
  template: `
      <div [ngStyle]="getStyles()" class="loading-item"></div>
  `,
  styleUrls: ["./skeleton-loader.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonLoaderComponent {
  @Input() width = "";
  @Input() height = "";
  @Input() circle = false;

  getStyles() {
    return {
      width: this.width ? this.width + "%" : "",
      height: this.height ? this.height + "%" : "30px;",
      "border-radius": this.circle ? "50%" : ""
    };
  }
}
